import getRandomNumber from "utils/getRandomNumber";

// const EXPERIENCE = getRandomNumber(1, 3);
const EXPERIENCE = 2;

export const getExperiment = () => EXPERIENCE;
